export const PRICE = 32.5;
export const COMPARE_PRICE = 40.0;
export const FREE_SHIPPING_THRESHOLD = 60;

export const FLAVORS = {
  tropical: {
    id: "tropical",
    name: "Tropical Fury",
    image: "/images/zenkai-tropical.jpg",
    theme: { accent: "#ff3b1f", accentRgb: "255, 59, 31", contrast: "#ffffff" },
  },
  apple: {
    id: "apple",
    name: "Wild Apple",
    image: "/images/zenkai-apple.jpg",
    theme: { accent: "#9fcc12", accentRgb: "159, 204, 18", contrast: "#111111" },
  },
};

export const DUO_IMAGE = "/images/zenkai-duo.jpg";

export const INGREDIENTS = [
  { key: "citrulline", name: "L-Citrulline DL-Malaat 2:1", mg: 8000 },
  { key: "beta_alanine", name: "Beta-Alanine", mg: 3200 },
  { key: "betaine", name: "Betaïne HCl", mg: 2000 },
  { key: "taurine", name: "Taurine", mg: 1000 },
  { key: "maltodextrin", name: "Maltodextrine", mg: 800 },
  { key: "caffeine", name: "Cafeïne (anhydrous)", mg: 300 },
  { key: "theanine", name: "L-Theanine", mg: 250 },
  { key: "salt", name: "Roze Himalayazout", mg: 250 },
  { key: "astragin", name: "AstraGin™", mg: 35 },
];

export const formatPrice = (v) => `€${v.toFixed(2).replace(".", ",")}`;
